module.exports = __webpack_public_path__ + "img/SecondaryHealingFullyRestoredBone.eddc9b53.jpg";